import {
  globalSearchParamsSchema,
  SEARCH_PARAM_ORG_ID,
  SEARCH_PARAM_SITE_ID,
} from 'routes/(global_search_params)/-searchParams'
import { modelKindSchema } from 'types'
import { z } from 'zod'

/** Row key of the asset the 3D Models viewer shows. */
export const SEARCH_PARAM_ASSET = 'asset'
/** Which of the asset's models is showing. */
export const SEARCH_PARAM_VIEW = 'view'

export const walkthroughSearchParams = z.object({
  ...globalSearchParamsSchema.shape,
  [SEARCH_PARAM_ASSET]: z.string().optional(),
  [SEARCH_PARAM_VIEW]: modelKindSchema.optional(),
})

export type WalkthroughSearch = z.infer<typeof walkthroughSearchParams>

export const createWalkthroughSearch = ({
  orgId,
  siteId,
  asset,
  view,
}: WalkthroughSearch) => ({
  [SEARCH_PARAM_ORG_ID]: orgId,
  [SEARCH_PARAM_SITE_ID]: siteId,
  [SEARCH_PARAM_ASSET]: asset,
  [SEARCH_PARAM_VIEW]: view,
})

export function createWalkthroughUrl(searchParams: WalkthroughSearch): string {
  const search = new URLSearchParams()

  for (const [key, value] of Object.entries(
    createWalkthroughSearch(searchParams)
  )) {
    if (value !== undefined) {
      search.set(key, value)
    }
  }

  const query = search.toString()

  return query ? `/walkthrough?${query}` : '/walkthrough'
}
